<?php

Namespace Model\DefaultModule;

class PageModel extends \Model\Base
{

    public static function bindMenu()
    {
        return function () {
            if (ISOPHP_EXECUTION_ENVIRONMENT === 'UNITER') {
                \ISOPHP\js_core::$console->log('Binding menu HS');
                $jQuery = \ISOPHP\js_core::$jQuery;
                $user_menu_html = self::getMenuHTML('user');
                $user_menu = $jQuery('#user-menu-button');
                $user_menu->html($user_menu_html);
                self::bindMenuLinks();
                /*$user_menu->on('mouseenter', function () use ($user_menu_html, $jQuery, $user_menu) {
                    \ISOPHP\js_core::$console->log('user menu mouseenter') ;
                    $user_menu->append($user_menu_html) ;
                    self::bindMenuLinks();
                }) ;
                $user_menu->on('mouseleave', function () use ($jQuery, $user_menu) {
                    \ISOPHP\js_core::$console->log('user menu mouseleave') ;
                    $jQuery('#user_menu_entries')->remove() ;
                }) ;
                $settings_menu_html = self::getMenuHTML('settings');
                $settings_menu = $jQuery('#settings-menu-button') ;
                $settings_menu->on('mouseenter', function () use ($settings_menu_html, $jQuery, $settings_menu) {
                    \ISOPHP\js_core::$console->log('settings menu mouseenter') ;
                    $settings_menu->append($settings_menu_html) ;                    
                    self::bindMenuLinks();
                }) ;
                $settings_menu->on('mouseleave', function () use ($jQuery, $settings_menu) {
                    \ISOPHP\js_core::$console->log('settings menu mouseleave') ;
                    $jQuery('#settings_menu_entries')->remove() ;
                }) ;*/
            }
        };
    }


    public static function bindMenuLinks()
    {
        if (ISOPHP_EXECUTION_ENVIRONMENT === 'UNITER') {
            \ISOPHP\js_core::$console->log('Binding menu links HS');

            $jQuery = \ISOPHP\js_core::$jQuery;
            $navigate = new \Model\Navigate();

            $user_menu_link_job_list = $jQuery('#user_menu_link_job_list');
            $user_menu_link_job_list->on('click', function () use ($navigate) {
                $navigate->route('JobList', 'show-to-user', array(), '/jobslist');
            });

            $user_menu_link_job_list = $jQuery('#user_menu_link_favorite_list');
            $user_menu_link_job_list->on('click', function () use ($navigate) {
                $navigate->route('JobList', 'show-user-favorite', array(), '/favorites');
            });

            $user_menu_link_applied_list = $jQuery('#user_menu_link_applied_list');
            $user_menu_link_applied_list->on('click', function () use ($navigate) {
                $navigate->route('JobList', 'show-user-applied', array(), '/applied');
            });

            $user_menu_link_interview_list = $jQuery('#user_menu_link_interview_list');
            $user_menu_link_interview_list->on('click', function () use ($navigate) {
                $navigate->route('UserAccount', 'show-interviews', array(), '/interviews');
            });

            $go_add_new_job = $jQuery('.go-add-new-job');
            $go_add_new_job->on('click', function ($jqThis) use ($navigate) {
                $jqThis->preventDefault();
                \ISOPHP\js_core::$console->log("Hello post you job from here 1!");
                $navigate->route('JobList', 'post-new-job', array(''), '/new-job-post');
            });

            $user_menu_link_my__post_jobs = $jQuery('#user_menu_link_my__post_jobs');
            $user_menu_link_my__post_jobs->unbind()->bind('click', function () use ($navigate) {
                $navigate->route('JobList', 'my-post-jobs', array(''), '/my-post-jobs');
            });

            $go_about_us = $jQuery('.go-about-us');
            $go_about_us->unbind()->bind('click', function () use ($navigate) {
                $navigate->route('LandingPage', 'about', array(''), '/about-us');
            });

            $go_contact_us = $jQuery('.go-contact-us');
            $go_contact_us->unbind()->bind('click', function () use ($navigate) {
                $navigate->route('LandingPage', 'contact', array(''), '/contact-us');
            });

            $go_terms_conditions = $jQuery('.go-terms-conditions');
            $go_terms_conditions->unbind()->bind('click', function () use ($navigate) {
                $navigate->route('LandingPage', 'terms', array(''), '/terms-and-conditions');
            });

            $go_privacy_policy = $jQuery('.go-privacy-policy');
            $go_privacy_policy->unbind()->bind('click', function () use ($navigate) {
                $navigate->route('LandingPage', 'privacy', array(''), '/privacy-policy');
            });

            $go_careerswithus = $jQuery('.go-careers-with-us');
            $go_careerswithus->unbind()->bind('click', function () use ($navigate) {
                $navigate->route('LandingPage', 'careerswithus', array(''), '/careers-with-us');
            });

            $go_affiliates = $jQuery('.go-affiliates');
            $go_affiliates->unbind()->bind('click', function () use ($navigate) {
                $navigate->route('LandingPage', 'affiliates', array(''), '/affiliates');
            });


            $settings_menu_billing = $jQuery('#logout');
            $settings_menu_billing->on('click', function () use ($navigate) {
                $navigate->route('Logout', 'now', array());
            });

            \ISOPHP\js_core::$console->log('Binding menu links HS End');
        }
    }

    public static function getMenuHTML($menu_type)
    {
        $user_logged = \ISOPHP\core::$registry->getValue('user_logged');
        $user = $user_logged;
        $user_type = $user['user']['user_type'];
        $html = '';

        if ($menu_type === 'user') {
            if ($user_type == 2) {
                $html = '
                    <div id="user_menu_entries" class="menu_entries user_menu_entries">
                        <!--<div class="menu_entry">
                            <span id="user_menu_link_job_list" class="btn btn-primary">Job List</span>
                        </div>-->
                        <div class="menu_entry">
                            <span id="user_menu_link_my__post_jobs" class="btn btn-primary">My Jobs</span>
                        </div>
                        <div class="menu_entry">
                            <span id="go-add-new-job" class="btn btn-primary go-add-new-job">Add Job+</span>
                        </div>
                        <div class="menu_entry">
                            <span id="logout" class="btn btn-warning">Logout</span>
                        </div>
                    </div>
                ';
            } else {
                $html = '
                    <div id="user_menu_entries" class="menu_entries user_menu_entries">
                        <div class="menu_entry">
                            <span id="user_menu_link_job_list" class="btn btn-primary">Job List</span>
                        </div>
                        <div class="menu_entry">
                            <span id="user_menu_link_favorite_list" class="btn btn-primary">My Favorites</span>
                        </div>
                        <div class="menu_entry">
                            <span id="user_menu_link_applied_list" class="btn btn-primary">Applied Jobs</span>
                        </div>
                        <div class="menu_entry">
                            <span id="user_menu_link_interview_list" class="btn btn-primary">My Interviews</span>
                        </div>
                        <div class="menu_entry">
                            <span id="logout" class="btn btn-warning">Logout</span>
                        </div>
                    </div>
                ';
            }

        }
        /*if ($menu_type === 'settings') {
            $html = '
                <div id="settings_menu_entries" class="menu_entries settings_menu_entries">
                    <div class="menu_entry">
                        <span id="settings_menu_billing">&nbsp;</span>
                    </div>
                </div>
            ' ;
        }*/

        // \ISOPHP\js_core::$console->log('menu html is ' . $html);
        return $html;
    }

}


// WEBPACK FOOTER //
// app/DefaultModule/Model/DefaultModulePageModel.php